export default __webpack_public_path__ + "static/char-09-79454aa886166657220129059da0d3da.webp";